import { NoDocuments } from 'assets/icons';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { GenerateContractsTableHeadings } from 'pages/ContractsPage/consts';
import { NoneOrders } from 'pages/Orders/NoneOrders';
import { useMutation, useQuery } from 'react-query';
import { modalActions } from 'reduxStore/reducers/ModalSlice';
import { EdmsService } from 'services/EdmsService';
import { FileDescriptorService } from 'services/FileDescriptorService';
import { PageWrapper } from 'ui/redesign/PageWrapper';
import { Table } from 'ui/redesign/Table';
import { TableCard } from 'ui/redesign/Table/TableCard';
import { Spinner } from 'ui/Spinner';
import { getOrganizationId, handleFileDownloadNew } from 'utils/helpers';
import { ftsStatusNameColor, styles } from './consts';
import { ExecutorOrganizationsListFormProps } from './types';

export const ExecutorOrganizationsListForm = ({ tableRow }: ExecutorOrganizationsListFormProps) => {
  const dispatch = useAppDispatch();
  const organizationId = getOrganizationId();

  const { data: executorOrganizations, isFetching: isExecutorOrganizationsFetching } = useQuery(
    ['getExecutorOrganizationsById'],
    () => EdmsService.getExecutorOrganizationsById(String(tableRow.id))
  );

  const executorData = executorOrganizations?.data;

  const { data: contractsData, isFetching: isContractsFetching } = useQuery(['getContracts'], () =>
    EdmsService.getContracts(String(tableRow.id), 0, 999)
  );

  // Скачать файл
  const { mutate: contractFileDownload } = useMutation(
    [`contractFileDownload`],
    (readLink: string) => FileDescriptorService.downloadSingleFile(readLink || ''),
    {
      onSuccess: (res) => {
        handleFileDownloadNew(res.data);
      },
    }
  );

  // Скачать контракт
  const { mutate: getContractById } = useMutation(
    [`getContractById`],
    (id: string) => EdmsService.getContractById(id),
    {
      onSuccess: (res) => {
        res.data.file.readLink && contractFileDownload(res.data.file.readLink);
      },
    }
  );

  const contracts = contractsData?.data;

  const headings = GenerateContractsTableHeadings({
    getContractById,
  }).slice(0, -1);

  const getFtsStatusColor = (ftsStatusName: string | null | undefined): string => {
    if (ftsStatusName === null || ftsStatusName === undefined) {
      return '';
    }

    if (ftsStatusName in ftsStatusNameColor) {
      return ftsStatusNameColor[ftsStatusName as keyof typeof ftsStatusNameColor];
    } else {
      return '';
    }
  };

  const statusColor = getFtsStatusColor(executorData?.ftsStatusName);

  return (
    <PageWrapper isGoBack={false}>
      {isExecutorOrganizationsFetching && isContractsFetching ? (
        <div className="flex">
          <Spinner />
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          <div className="w-full pb-1">
            <p className={styles.label}>Статус проверки ФНС</p>
            <h2 className={statusColor}>{executorData?.ftsStatusName}</h2>
          </div>
          <div className="flex flex-col justify-between gap-4 sm:flex-row">
            <div className="w-full border-b border-[#E4E4E5] pb-1 sm:max-w-[650px]">
              <p className={styles.label}>ФИО</p>
              <h2 className={styles.value}>{executorData?.fullName}</h2>
            </div>
            <div className="w-full border-b border-[#E4E4E5] pb-1 sm:max-w-[650px]">
              <p className={styles.label}>ИНН</p>
              <h2 className={styles.value}>{executorData?.tin}</h2>
            </div>
          </div>
          <div className="flex flex-col justify-between gap-4 sm:flex-row">
            <div className="w-full border-b border-[#E4E4E5] pb-1 sm:max-w-[650px]">
              <p className={styles.label}>Номер телефона</p>
              <h2 className={styles.value}>{executorData?.phoneNumber}</h2>
            </div>
            <div className="w-full border-b border-[#E4E4E5] pb-1 sm:max-w-[650px]">
              <p className={styles.label}>E-mail</p>
              <h2 className={styles.value}>{executorData?.email}</h2>
            </div>
          </div>
          <h1 className="mb-1 text-text-100">Информация о договорах</h1>
          {!contracts?.totalCount ? (
            <div>
              <NoneOrders
                icon={<NoDocuments className="h-16 w-16" />}
                heading="Данные отсутствуют"
                description={'Нет ни одного созданного договора'}
              />
            </div>
          ) : (
            <div className="max-h-96 overflow-scroll text-text-100">
              <TableCard>
                <Table
                  tableHeading={headings}
                  tableData={(contracts?.items || []) as unknown as TableData[]}
                />
              </TableCard>
            </div>
          )}
        </div>
      )}
    </PageWrapper>
  );
};
